import React from 'react';

type MetaProps = {
    children?: JSX.Element | JSX.Element[]
}

const Meta : React.FC<MetaProps> = ( { children } ) : React.ReactElement => (
    <>
        <link rel="icon" href="/favicon/favicon.ico" sizes="any" />
        <link rel="icon" href="/favicon/favicon.svg" type="image/svg+xml" />
        <link rel="manifest" href="/favicon/site.webmanifest" />
        {children}
    </>
);

export default Meta;
